import type { InventoryItem } from '../types';

const now = Date.now();
const d = 86400000; // milliseconds in a day

export const initialInventory: InventoryItem[] = [
  { id: 1, name: 'Beef Patties', stock: 50, unit: 'units', lowStockThreshold: 20, lastUpdated: now - d * 2 },
  { id: 2, name: 'Burger Buns', stock: 80, unit: 'units', lowStockThreshold: 40, lastUpdated: now - d * 1 },
  { id: 3, name: 'Cheddar Cheese Slices', stock: 200, unit: 'units', lowStockThreshold: 100, lastUpdated: now - d * 3 },
  { id: 4, name: 'Tomatoes', stock: 10, unit: 'kg', lowStockThreshold: 5, lastUpdated: now },
  { id: 5, name: 'Lettuce Heads', stock: 15, unit: 'units', lowStockThreshold: 10, lastUpdated: now },
  { id: 6, name: 'Potatoes', stock: 50, unit: 'kg', lowStockThreshold: 20, lastUpdated: now - d * 5 },
  { id: 7, name: 'Cooking Oil', stock: 25, unit: 'L', lowStockThreshold: 10, lastUpdated: now - d * 10 },
  { id: 8, name: 'Salt', stock: 5, unit: 'kg', lowStockThreshold: 2, lastUpdated: now - d * 30 },
  { id: 9, name: 'Cola Syrup', stock: 5, unit: 'L', lowStockThreshold: 2, lastUpdated: now - d * 4 },
  { id: 10, name: 'Coffee Beans', stock: 8, unit: 'kg', lowStockThreshold: 4, lastUpdated: now - d * 6 },
  { id: 11, name: 'Milk', stock: 9, unit: 'L', lowStockThreshold: 5, lastUpdated: now - d * 1 },
  { id: 12, name: 'Salmon Fillets', stock: 8, unit: 'units', lowStockThreshold: 10, lastUpdated: now - d * 3 },
];